import { APITimeline } from '@cxc/ui-kit/chart.js/components/timeline';
import { Chart } from '@cxc/ui-kit/chart.js/models';

import { FxDisclosureWire } from '@models/API/fx-disclosure.model';
import { Insights } from '@models/operation/insights.model';
import { Operation as _Operation } from '@models/operation/operation.model';

export namespace Lender {
  export namespace Overview {
    export namespace Resume {
      export interface Operation {
        status: string;
        external_id: string;
        trust_number: string;
        alias: string;
        trustee: string;
        lenders: _Operation.Member[];
        originators: _Operation.Member[];
        currency: string;
        total_credit_amount: number;
        total_contracts: number;
        finished_operation_date?: string;
        created_at: string;
        updated_at: string;
        reported_at: string;
        master_admin?: string;
        charts: Chart.V1.Chart[];
      }
      export interface Response {
        lender: string;
        reported_at: string;
        core_metrics: Lender.CoreMetrics.Response;
        overview: APITimeline;
        operations: Operation[];
        carrousel_charts: Chart.V1.Chart[];
        first_chart: Chart.V1.Chart;
      }
    }

    export type Response = APITimeline;
  }

  export namespace CoreMetrics {
    export interface Response {
      reported_at: string;
      lender: string;
      interest_rate: number;
      outstanding_debt: number;
      total_contracts: number;
      operations: {
        trust_number: string;
        alias: string;
        interest_rate: number;
        outstanding_debt: number;
        total_contracts: number;
        total_credit_amount: number;
        currency: string;
      }[];
      total_credit_amount: number;
      currency: string;
      portfolio_balance: {
        elegible: number;
        inelegible: number;
        total: number;
      };
      pending_update_operations: string[];
      spread: number;
      // LEN-1809: present only when `outstanding_debt`/`portfolio_balance`
      // were actually converted - not `total_credit_amount` (see the
      // backend's own `LenderDetail.fx` docstring for why that one can't be
      // covered by a single disclosure).
      fx?: FxDisclosure;
    }
  }

  /** The rate behind a converted figure, so an export can say where it came
   * from. An alias, not a second interface: both mirrored the backend's
   * `FxDisclosure` (`schemas/charts.py`) field by field, and two copies meant
   * a backend rename would update one and leave the compiler silent about the
   * other (MR !1207 S4). `FxDisclosureWire` is the copy that gets promoted to
   * `Chart.Base` when LEN-2142 brings the second consumer. */
  export type FxDisclosure = FxDisclosureWire;

  export namespace Matrix {
    export type Response = Insights.Matrix[];
  }

  export namespace Charts {
    export type Response = Chart.V1.Chart[];
  }

  export enum ChartName {
    TOTAL_CREDIT_AMOUNT = 'TOTAL_CREDIT_AMOUNT',
    AGING_SNAPSHOTS = 'AGING_SNAPSHOTS',

    COLLECTION_SNAPSHOTS = 'COLLECTION_SNAPSHOTS',
    ASSETS_SNAPSHOTS = 'ASSETS_SNAPSHOTS',
    BORROWINGS_SNAPSHOTS = 'BORROWINGS_SNAPSHOTS',
    OVERCOLLATERIZATIONS_SNAPSHOTS = 'OVERCOLLATERIZATIONS_SNAPSHOTS',
    PAYMENT_HISTORY = 'PAYMENT_HISTORY',
  }
}
